import { LegalLayout } from './LegalLayout';

const SUPPORT_EMAIL = 'support@radiologylive.ai';
const LAST_UPDATED = '2026-02-26';

export default function Hipaa() {
  return (
    <LegalLayout title="Healthcare Compliance (HIPAA)">
      <p className="text-sm text-muted-foreground">Last updated: {LAST_UPDATED}</p>

      <p>
        RadiologyLive.ai is built for clinical workflows. This page describes our approach to privacy
        and security and clarifies responsibilities.
      </p>

      <h2>1. Default mode: no patient identifiers</h2>
      <p>
        By default, RadiologyLive.ai is intended for workflows that do not require patient identifiers.
        Unless and until RadiologyLive.ai explicitly enables a HIPAA/BAA-backed workflow, you must not
        provide PHI (including patient name, MRN, DOB, accession, address, phone, email).
      </p>

      <h2>2. Shared responsibility model</h2>
      <p>
        HIPAA compliance is shared between your organization and its vendors. Your organization is
        responsible for policies, procedures, access governance, and appropriate operational
        controls.
      </p>

      <h2>3. Auditability</h2>
      <p>
        We maintain security and audit logging designed to support investigation of account activity
        and operational events.
      </p>

      <h2>4. External processing</h2>
      <p>
        If any workflow involves processing outside RadiologyLive.ai-controlled infrastructure (for
        example, third-party AI providers), RadiologyLive.ai will require explicit user consent and will
        document the workflow scope here before enabling it for PHI.
      </p>

      <h2>5. Contact</h2>
      <p>
        Compliance questions: <a className="text-primary hover:underline" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
      </p>

      <p className="text-xs text-muted-foreground">
        Disclaimer: This page is informational and does not constitute legal advice.
      </p>
    </LegalLayout>
  );
}
